/* eslint-disable */
// Based on https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure

class Disclosure {
    constructor() {
        this.instances = document.querySelectorAll('[data-progressive-enhancement="off"][data-progressive-enhancement-type="disclosure"]');

        this.disclosuresStatus = null;
    }

    init(helpers) {
        const self = this;

        this.helpers = helpers;

        self.enhanceAll(self);
    }

    createButtonSVG(name) {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'),
            path = document.createElementNS('http://www.w3.org/2000/svg', 'path');

            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            svg.setAttribute('viewBox', '0 0 12 7');
            svg.setAttribute('width', '10');
            svg.setAttribute('height', '6');
            svg.setAttribute('aria-hidden', 'true');

            switch(name) {
                case 'chevron--down':
                    path.setAttribute('d', 'M10.8727 0.2925C10.4827 -0.0975 9.85274 -0.0975001 9.46274 0.2925L5.58274 4.1725L1.70274 0.2925C1.31274 -0.0975004 0.682741 -0.0975005 0.292741 0.2925C-0.0972596 0.6825 -0.0972596 1.3125 0.292741 1.7025L4.88274 6.2925C5.27274 6.6825 5.90274 6.6825 6.29274 6.2925L10.8827 1.7025C11.2627 1.3225 11.2627 0.6825 10.8727 0.2925Z');
                    path.setAttribute('fill', 'currentColor');
                    path.setAttribute('data-d', 'M10.8727 0.2925C10.4827 -0.0975 9.85274 -0.0975001 9.46274 0.2925L5.58274 4.1725L1.70274 0.2925C1.31274 -0.0975004 0.682741 -0.0975005 0.292741 0.2925C-0.0972596 0.6825 -0.0972596 1.3125 0.292741 1.7025L4.88274 6.2925C5.27274 6.6825 5.90274 6.6825 6.29274 6.2925L10.8827 1.7025C11.2627 1.3225 11.2627 0.6825 10.8727 0.2925Z');
                    path.setAttribute('data-d-alt', 'M10.8725 6.29246C10.4825 6.68246 9.8525 6.68246 9.4625 6.29246L5.5825 2.41246L1.7025 6.29246C1.3125 6.68246 0.682497 6.68246 0.292497 6.29246C-0.0975033 5.90246 -0.0975034 5.27246 0.292497 4.88246L4.8825 0.292461C5.2725 -0.0975388 5.9025 -0.0975388 6.2925 0.292461L10.8825 4.88246C11.2625 5.26246 11.2625 5.90246 10.8725 6.29246Z'); 
            }   

            svg.appendChild(path);

            return svg;
    }

    enhance(instance, self) {
        let button,
            disclosureContents,
            heading,
            options,
            path,
            svg;

        if(
            ('LI' !== instance.tagName)
            && ('DIV' !== instance.tagName)
            && ('SECTION' !== instance.tagName)
        ) {
            return;
        }

        switch(instance.tagName) {
            // case 'DT': {
            //     if(!instance.nextElementSibling) {
            //         return;
            //     }

                
            //     if('DD' !== instance.nextElementSibling.tagName) {
            //         return;
            //     }

            //     console.log('DT');

            //     disclosureContents = instance.parentElement.querySelectorAll('dt[data-progressive-enhancement][data-progressive-enhancement-type="disclosure"] + dd, dt[data-progressive-enhancement][data-progressive-enhancement-type="disclosure"] + dd ~ :not(dt) ~ dd');

            //     // for(let element of disclosureContents) {
            //     //     element.classList.add('js-disclosure-content');
            //     // }

            //     if(
            //         instance.dataset.progressiveEnhancementOptions
            //         && self.helpers.isValidJSON(instance.dataset.progressiveEnhancementOptions)
            //     ) {
            //         options = JSON.parse(instance.dataset.progressiveEnhancementOptions);
            //     }

            //     let labellingElement = instance,
            //         labellingElementNodes;

            //     button = self.helpers.createButton('');

            //     while(labellingElement.childNodes[0]) {
            //         button.appendChild(labellingElement.removeChild(labellingElement.childNodes[0]));
            //     }

            //     labellingElement.appendChild(button);

            //     break;
            // }
            case 'LI': {
                if(2 !== instance.children.length) {
                    return;
                }

                if(!self.helpers.listTagnames.includes(instance.children[1].tagName)) {
                    return;
                }

                disclosureContents = [instance.children[1]];

                if(
                    instance.dataset.progressiveEnhancementOptions
                    && self.helpers.isValidJSON(instance.dataset.progressiveEnhancementOptions)
                ) {
                    options = JSON.parse(instance.dataset.progressiveEnhancementOptions);
                }
                console.log(instance.dataset.progressiveEnhancementOptions);

                switch(instance.closest('nav')) {
                    case true: {
                        if('A' !== instance.children[0].tagName) {
                            return;
                        }
                        let a = instance.children[0],
                            buttonLabelValue = a.textContent + ' ' + i18n.Disclosure.subMenu,
                            div = document.createElement('div');

                        button = self.helpers.createButton('');
                        
                        instance.insertBefore(div, a);
                        div.appendChild(instance.removeChild(a));
                        div.appendChild(button);

                        button.setAttribute('aria-label', buttonLabelValue);

                        break;
                    }
                    default: {
                        let labellingElement = instance.children[0],
                            labellingElementNodes;

                        button = self.helpers.createButton('');

                        while(labellingElement.childNodes[0]) {
                            button.appendChild(labellingElement.removeChild(labellingElement.childNodes[0]));
                        }

                        labellingElement.parentElement.replaceChild(button, labellingElement);
                    }
                }

                break;
            }
            case 'DIV':
            case 'SECTION': {
                if(!instance.id) {
                    return;
                }

                if(!instance.hasAttribute('aria-labelledby')) {
                    return;
                }

                if(!instance.querySelector('#' + instance.getAttribute('aria-labelledby'))) {
                    return;
                }
                
                if(!self.helpers.headingTagnames.includes(instance.querySelector('#' + instance.getAttribute('aria-labelledby')).tagName)) {
                    return;
                }

                let headingNodes;

                button = self.helpers.createButton('');
                
                heading = instance.querySelector('#' + instance.getAttribute('aria-labelledby'));
                    
                if(
                    instance.dataset.progressiveEnhancementOptions
                    && self.helpers.isValidJSON(instance.dataset.progressiveEnhancementOptions)
                ) {
                    options = JSON.parse(instance.dataset.progressiveEnhancementOptions);
                }

                if(
                    (1 === heading.children.length)
                    && ('A' === heading.children[0].tagName)
                ) {
                    let a = heading.querySelector('a'),
                        aNodes = a.childNodes;

                    while(a.childNodes[0]) {
                        heading.appendChild(a.removeChild(a.childNodes[0]));
                    }

                    heading.removeChild(a);
                }

                while(heading.childNodes[0]) {
                    button.appendChild(heading.removeChild(heading.childNodes[0]));
                }

                heading.appendChild(button);
                
                disclosureContents = instance.parentElement.querySelectorAll('#' + instance.id + ' > :not(#' + heading.id + ')');
            }
        }

        if (
            options
            && ('true' === options['aria-expanded'])
        ) {
            for(let element of disclosureContents) {
                element.classList.add('js-disclosure-content');
            }
            
            button.setAttribute('aria-expanded', 'true');
        } else {
            for(let element of disclosureContents) {
                element.classList.add('js-disclosure-content');
                self.helpers.accessibleHide(element);
            }
            
            button.setAttribute('aria-expanded', 'false');
        }

        svg = self.createButtonSVG('chevron--down');

        svg.setAttribute('class', 'button__toggle');
    
        button.appendChild(document.createTextNode(' '));
        
        button.appendChild(svg);

        path = button.querySelector('svg.button__toggle > path');

        if (
            options
            && ('true' === options['aria-expanded'])
        ) {
            path.setAttribute('d', path.getAttribute('data-d-alt'));
        } else {
            path.setAttribute('d', path.getAttribute('data-d'));
        }


        button.addEventListener('click', e => self.toggleContent(e, self));

        instance.dataset.progressiveEnhancement = 'on';
    }

    enhanceAll(self) {
        if (self.disclosuresStatus !== 'on') {
            for (let instance of self.instances) {
                instance = self.enhance(instance, self);
            }

            self.disclosuresStatus = true;
        }

        if(self.disclosuresStatus) {
            if(document.documentElement.dataset.progressiveEnhancements) {
                document.documentElement.dataset.progressiveEnhancements += ' disclosure';
            } else {
                document.documentElement.dataset.progressiveEnhancements = 'disclosure';
            } 
        }
    }

    toggleContent(e, self) {
        if('click' !== e.type) {
            return;
        }

        if('BUTTON' !== e.currentTarget.tagName) {
            return;
        }

        if('button' !== e.currentTarget.type) {
            return;
        }

        if(!e.currentTarget.hasAttribute('aria-expanded')) {
            return;
        }

        if('' === e.currentTarget.getAttribute('aria-expanded')) {
            return;
        }

        if(
            ('false' !== e.currentTarget.getAttribute('aria-expanded'))
            && ('true' !== e.currentTarget.getAttribute('aria-expanded'))
        ) {
            return;
        }

        let button = e.currentTarget,
            instance = button.closest('[data-progressive-enhancement="on"][data-progressive-enhancement-type="disclosure"]'),
            disclosureContents = instance.querySelectorAll('.js-disclosure-content'),
            path = button.querySelector('svg.button__toggle > path');

        if ('false' === button.getAttribute('aria-expanded')) {
            for(let element of disclosureContents) {
                self.helpers.accessibleShow(element);
            }

            button.setAttribute('aria-expanded', 'true');
            path.setAttribute('d', path.getAttribute('data-d-alt'));
        } else {
            for(let element of disclosureContents) {
                self.helpers.accessibleHide(element);
            }

            button.setAttribute('aria-expanded', 'false');
            path.setAttribute('d', path.getAttribute('data-d'));
        }
    }
}// end Class

// Singleton
export default Disclosure;